
// ModalExibirItensVenda.js

import React, { useEffect } from 'react';
import './ModalExibirItens.css'; // Certifique-se de que o caminho está correto e que o arquivo CSS existe

function ModalExibirItensVenda({ isOpen, fecharModal, itensVenda, codVenda }) {
  useEffect(() => {
    if (isOpen) {
      console.log("Exibindo itens da venda:", codVenda);
      console.log("Itens da venda:", itensVenda);
    }
  }, [isOpen, codVenda, itensVenda]);

    const handleCloseModal = () => {
    fecharModal();
  };

  // Função para formatar os valores para BRL
  const formatarValorBRL = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };


  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={handleCloseModal}>&times;</span>
        <h3>Itens da Venda: {codVenda}</h3>
        <table>
          <thead>
            <tr>
              <th className="coluna-produto">Produto</th>
              <th className="coluna-quantidade">Quantidade</th>
              <th className="coluna-valunit">Valor Unitário</th> {/* Adicione a classe aqui */}
              <th className="coluna-valitem" translate="no">Valor Item</th>
            </tr>
          </thead>
          <tbody>
            {itensVenda && itensVenda.map((item, index) => (
              <tr key={index}>
                <td className="coluna-produto">{item.produto}</td>
                <td className="coluna-quantidade">{item.quantidade}</td>
                <td className="coluna-valunit">{formatarValorBRL(item.valunit)}</td>
                <td className="coluna-valitem">{formatarValorBRL(item.valitem)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
      </div>
    </div>
  );
}

export default ModalExibirItensVenda;
